import { FormFieldProps } from 'components/inspection/Form/types';
import { ProjectSetupTranslationKeys } from 'intl/keys';
import { OrganizationCreateModel } from 'shared/domain/organization/types/model';
import { ReactElement, useMemo } from 'react';
import { OrganizationFormPresentational } from './presentational';

export function OrganizationForm({
  isDialog,
}: {
  isDialog: boolean;
}): ReactElement {
  const nameFieldProps: FormFieldProps<OrganizationCreateModel> = useMemo(
    () => ({
      formKey: 'name',
      required: true,
      labelId: ProjectSetupTranslationKeys.name,
      fieldName: 'text-field-organization-name',
      dense: true,
      reserveSpaceForHelperText: !isDialog,
      'data-qa': 'organization_name_field',
      localStorageKey: ProjectSetupTranslationKeys.name,
      issueParams: null,
    }),
    [isDialog]
  );
  const labelFieldProps: FormFieldProps<OrganizationCreateModel> = useMemo(
    () => ({
      formKey: 'label',
      required: true,
      labelId: ProjectSetupTranslationKeys.label,
      fieldName: 'text-field-organization-label',
      dense: true,
      reserveSpaceForHelperText: !isDialog,
      'data-qa': 'organization_label_field',
      localStorageKey: ProjectSetupTranslationKeys.label,
      issueParams: null,
    }),
    [isDialog]
  );
  const contactEmailFieldProps: FormFieldProps<OrganizationCreateModel> =
    useMemo(
      () => ({
        formKey: 'contactEmail',
        required: true,
        labelId: ProjectSetupTranslationKeys.contactEmail,
        fieldName: 'text-field-organization-contactEmail',
        dense: true,
        reserveSpaceForHelperText: !isDialog,
        'data-qa': 'organization_contactEmail_field',
        localStorageKey: ProjectSetupTranslationKeys.contactEmail,
        issueParams: null,
      }),
      [isDialog]
    );

  return (
    <OrganizationFormPresentational
      nameFieldProps={nameFieldProps}
      labelFieldProps={labelFieldProps}
      contactEmailFieldProps={contactEmailFieldProps}
    />
  );
}
